import React from 'react';
import '../components/PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <header className="privacy-policy-header">
          <h1>プライバシーポリシー</h1>
          <p className="last-updated">最終更新日: 2026年9月28日</p>
        </header>
        
        <div className="privacy-policy-content">
          <section className="privacy-section">
            <h2>1. 個人情報の収集</h2>
            <p>
              当税務アシスタントアプリでは、以下の情報を収集いたします：
            </p>
            <ul>
              <li>給与所得、賞与などの収入情報</li>
              <li>扶養家族の情報（氏名、年齢、所得など）</li>
              <li>各種控除に関する情報</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>2. 利用目的</h2>
            <p>
              収集した個人情報は以下の目的で利用いたします：
            </p>
            <ul>
              <li>所得税・住民税等の計算</li>
              <li>各種控除額の算出</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. 情報の管理・保護</h2>
            <p>
              お預かりした個人情報は適切に管理し、不正アクセス、紛失、破損、改ざん、漏洩などを防止するため、
              必要かつ適切な安全管理措置を講じます。
            </p>
          </section>

          <section className="privacy-section">
            <h2>4. 第三者への提供</h2>
            <p>
              当アプリでは、個人情報を第三者に提供することはありません。
              Google Drive 連携によるバックアップは、利用者自身の Google Drive の
              アプリ専用領域（appDataFolder）へ保存されるものであり、当アプリの運営者が
              その内容を取得・閲覧することはありません。これは第三者への提供には該当しません。
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Google Drive 連携（バックアップ・復元）</h2>
            <p>
              本アプリのバックアップ・復元機能は、Google Identity Services（GIS）を利用して
              利用者本人の Google アカウントの許可を得たうえで、利用者自身の Google Drive の
              アプリ専用領域（appDataFolder）に給与データを保存・取得します。
              アクセス範囲はアプリ専用領域に限定され、その他のファイルへアクセスすることはありません。
            </p>
            <ul>
              <li>
                アクセストークンはブラウザのメモリ上でのみ保持し、localStorage・sessionStorage・
                Cookie 等へ永続的に保存しません（約1時間で失効し、その都度再認証が必要です）。
              </li>
              <li>
                バックアップデータが当アプリのサーバを経由して保存・収集されることはありません。
                データは利用者自身の Google Drive 内に留まります。
              </li>
              <li>
                Google アカウントの認証・認可および Google Drive の利用には、Google の
                利用規約およびプライバシーポリシーが適用されます。
                詳細は Google プライバシーポリシー
                （https://policies.google.com/privacy）をご確認ください。
              </li>
              <li>
                連携を解除するには、本アプリの「Google Drive認証解除」を押すか、Google アカウントの
                セキュリティ設定から本アプリのアクセス権を削除してください。
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. データの保存期間</h2>
            <p>
              収集した個人情報は、利用目的達成後、適切な期間内に削除いたします。
              Google Drive 上のバックアップは利用者自身の領域に保存され、利用者がいつでも削除できます。
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Cookieの使用</h2>
            <p>
              当アプリでは、サービス向上のためCookieを使用する場合があります。
              Cookieの使用を望まない場合は、ブラウザの設定で無効にすることができます。
              ただし、Cookieを無効にすると、一部の機能が利用できなくなる場合があります。
              Google Drive 連携の認証情報は Cookie には保存しません。
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. プライバシーポリシーの変更</h2>
            <p>
              本プライバシーポリシーは、法令の改正や事業内容の変更等により、
              予告なく変更する場合があります。変更後のプライバシーポリシーは、
              本ページに掲載された時点から効力を生じるものとします。
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. お問い合わせ</h2>
            <p>
              個人情報の取扱いに関するお問い合わせは、以下までご連絡ください：
            </p>
            <div className="contact-info">
              <p>税務アシスタント サポート窓口</p>
              <p>メール: zatton-apps@googlegroups.com</p>
            </div>
          </section>
        </div>

        <div className="privacy-policy-actions">
          <button 
            className="back-button"
            onClick={() => window.history.back()}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
